module.exports = __webpack_public_path__ + "media/images/uk-lang-a982267f13a651a52662932e97d81931.png";